import styled from 'styled-components'
import { ContainerSombra } from '../../components/ContainerSombra'

export const configuracoesGeraisStyles = {
  Container: styled(ContainerSombra)`
    padding: 24px;
  `
}
